import angular = require("angular");
import TPL = require("templates");

export class InputSelectDirective {

  template = TPL.commonDirectives.inputSelect;
  scope = {
    params: "=params"
  };

  link;

  constructor() {
    this.link = (scope, el, attrs) => {
        scope.vm = {
          toggle: (array, type, multiple) => {
            if(multiple === true) {
              var index = array.indexOf(type);
              if (index >= 0) {
                array.splice(index, 1);
              } else {
                array.push(type);
              }
            } else {
              var index = array.indexOf(type);
              if (index >= 0) {
                array.splice(index, 1);
              } else {
                array.splice(0,1);
                array.push(type);
              }
            }
          },
          contains: (array, type): boolean =>{
            if(array != null) {
                return array.indexOf(type) >= 0;
            } else {
              return false;
            }
          }
      }
    }
  }


  static factory() {
    var tmp = () => new InputSelectDirective();
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/inputSelect.ts
 **/